<div *ngIf="isLoadingView" class="card bg-gray-800 border-0 overflow-hidden">
  <!-- BEGIN card-body -->
  <div class="panel panel-inverse">
    <div class="panel-heading custom-heading">
      <h4 class="panel-title custom-title">Plan Protection</h4>
      <div class="d-flex flex-row">
        <button *ngIf="filtros" class="btn btn-primary" (click)="mostrarFiltros()">Ocultar Filtros <i class="ms-2 fa-solid fa-eye-slash"></i></button>
        <button *ngIf="!filtros" class="btn btn-primary" (click)="mostrarFiltros()">Mostrar Filtros <i class="fa-solid fa-eye ms-2"></i></button>
      </div>
    </div>
    <div class="panel-body">
      <div *ngIf="filtros" class="row mb-3 d-flex align-items-end">
        <div class="col-lg-2">
          <span class="fs-12px"><b>Folio PP</b></span>
          <input [(ngModel)]="folioFilter" class="form-control" placeholder="Escribe un folio del PP para filtrar..."  (keydown.enter)="getData(2)" (ngModelChange)="setearFiltroReset()"/>
        </div>
        <div class="col-lg-2">
          <span class="fs-12px"><b>Nombre Cliente</b></span>
          <input [(ngModel)]="clienteFilter" class="form-control" placeholder="Escribe un cliente para filtrar..." (keydown.enter)="getData(2)"  (ngModelChange)="setearFiltroReset()"/> <!--(keyup)="updateFilter($event, 'userName')" -->
        </div>
        <div class="col-lg-2">
          <span class="fs-12px"><b>Celular</b></span>
          <input [(ngModel)]="celularFilter" class="form-control" placeholder="Escribe un no. celular para filtrar..."  (keydown.enter)="getData(2)"  (ngModelChange)="setearFiltroReset()"/> <!--(keyup)="updateFilter($event, 'lastName')" -->
        </div>
        <div class="col-lg-2">
          <span class="fs-12px"><b>Placas</b></span>
          <input [(ngModel)]="placasFilter" class="form-control" style="text-transform: uppercase;" placeholder="Escribe una placa para filtrar..."  (keydown.enter)="getData(2)"  (ngModelChange)="setearFiltroReset()"/> <!--(keyup)="updateFilter($event, 'lastName')" -->
        </div>
        <div class="col-lg-2">
          <span class="fs-12px"><b>Estatus</b></span>
          <select class="form-control" name="" [(ngModel)]="estatusFilter" id="">
            <option value="">Todos</option>
            <option *ngFor="let est of estatus" [value]="est.nombre">{{est.nombre}}</option>
          </select>
        </div>
        <div class="col-lg-2">
          <span class="fs-12px"><b>Sucursal</b></span>
          <!-- <input [(ngModel)]="sucursalFilter" class="form-control" placeholder="Escribe una sucursal para filtrar..."  (keydown.enter)="getData(2)" /> (keyup)="updateFilter($event, 'lastName')" -->
          <mat-select multiple class="form-control fuente-controles" placeholder="Seleccionar oppciones" [(value)]="selectedOptionsSucursales">        
            <input type="text" [(ngModel)]="filtroSucursal" placeholder="Buscar sucursal..." class="form-control fuente-controles" (ngModelChange)="filtrarSucursales($event)"/>
            <mat-checkbox (change)="toggleAllSucursales($event)" [checked]="isAllSelectedSucursales()" [indeterminate]="isIndeterminateSucursales()"><label class="fuente-controles" style="color: red;">Seleccionar todas</label> </mat-checkbox> 
            <mat-option class="fuente-controles" *ngFor="let sucursal of sucursalesFiltradas" [value]="sucursal" (click)="getData(2)">{{sucursal.nombreSucursal}}</mat-option>          
          </mat-select>  
        </div>
        <div class="col-lg-2 mt-2">
          <button class="btn btn-primary w-100" (click)="getData(1)">Buscar</button>
        </div>
        <!-- <div class="col-lg-2 col-6">
          <span class="fs-12px"><b>Orden Venta</b></span>
          <input [(ngModel)]="ovFilter" class="form-control" placeholder="Escribe una orden de venta para filtrar..."  (keydown.enter)="getData(2)" /> 
        </div> -->
        <!-- <div class="col-lg-2">
          <span class="fs-12px"><b>Sucursal</b></span>
          <input [(ngModel)]="sucFilter" class="form-control" placeholder="Escribe una sucursal para filtrar..."  (keydown.enter)="getData(2)" /> 
        </div> -->
        <!-- <div class="col-lg-2 d-flex justify-content-end mt-2">
          <button class="btn btn-primary" (click)="getData(1)">Buscar</button>
        </div> -->
        
      </div>

      <div *ngIf="pagination && listaProveedores.length > 0" #tablaContenedor class="table-responsive text-nowrap" [ngClass]="{'max-height-filters': filtros, 'max-height-without-filters': !filtros }">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th *ngFor="let columna of columnas">
                  <span (click)="toggleOrder(columna.orderby)">{{columna.title}}</span>
                </th>                
              </tr>
            </thead>
            <tbody>
              <tr (click)="editarRegistro(item)" *ngFor="let item of listaProveedores;">
                <td class="align-middle ">  
                    <div class="d-flex justify-content-between align-items-center">
                      <b style="text-decoration: underline; cursor: pointer;">{{item.folio}}</b>     
                    </div>                      
                  </td>
                  <td class="align-middle" style="text-transform: capitalize;"> 
                    <span class="badge me-1 fs-12px" [ngClass]="{'bg-danger': item.estatus !== 'Vigente', 'bg-success': item.estatus === 'Vigente'}">{{item.estatus}}</span>
                  </td>
                  <td *ngIf="isGerente()" class="align-middle" style="text-transform: capitalize;"> {{item.nombreVendedor}} </td>
                  <td class="align-middle"> {{item.ordenVentaId}} </td>
                  <td class="align-middle" >{{item.nombreSucursal}}</td>
                  <td class="align-middle " style="text-transform: capitalize;">{{item.nombreCliente}}</td>
                  <td class="align-middle " style="text-transform: uppercase;">{{item.placas}}</td>
                  <td class="align-middle ">{{item.celular}}</td>
                  <td class="align-middle" >
                    <span class="me-1 fs-12px">{{item.fechaVenta | date: 'dd/MM/yyyy'}}</span>
                  </td>
                  <td class="align-middle" >
                    <span class="me-1 fs-12px">{{item.fechaVigencia | date: 'dd/MM/yyyy'}}</span>
                  </td>
              </tr>
            </tbody>
          </table>
      </div>
      <div *ngIf="listaProveedores.length === 0" class="d-flex flex-column justify-content-center align-items-center" style="height: 40vh">
          <i class="fa-solid fa-triangle-exclamation" style="color: #f3d41e; font-size: 36px;"></i>
          <p style="color: black; font-size: 16px; max-width: 400px; text-align: center;"><b>No se encontraron resultados.</b></p>
      </div>
      <div *ngIf="pagination && pagination.totalPages > 1" class="d-flex flex-row justify-content-center align-items-center">
        <div class="row">
          <div class="col-12">
              <div class="btn-group d-flex flex-row align-items-center" role="group">
                  <button class="btn btn-outline-secondary" style="margin-right: 8px;" (click)="gotoPage('<')" *ngIf="pagination.currentPage > 1"><</button>
                  <!-- <span class="ms-2">Página {{paginator.pageNumber}}</span> -->
                  <button type="button"
                          *ngFor="let page of pages"
                          title="{{page.title}}"
                          class="btn" (click)="gotoPage(page.id)"
                          [ngClass]="{'btn-outline-secondary': pagination.currentPage != page.id, 'btn-primary': pagination.currentPage == page.id }">
                      {{page.text}}
                  </button>
                  <button class="btn btn-outline-secondary ms-2" (click)="gotoPage('>')" *ngIf="pagination.currentPage < pagination.totalPages">></button>
              </div>
          </div>
        </div>
        <!-- <div class="col-sm-2  form-group form-inline margin-responsive-mobile">
          <select [(ngModel)]="paginator.itemsPerPage" class="form-control form-select ml-2" (change)="cambioDropdown($event.target.value)">
            <option *ngFor="let option of elementos" [value]="option">{{option}} items</option>
          </select>
        </div> -->
      </div>
      <div *ngIf="pagination && listaProveedores.length > 0" class="row">
        <div class="col-12 align-items-center justify-content-center d-flex">
          <span>{{pagination.label}}</span>
        </div>
      </div>
      <!-- <div #tablaContenedor >
        <ngx-datatable
          class="bootstrap"
          [columns]="columns"
          [columnMode]="ColumnMode.force"
          [headerHeight]="50"
          [footerHeight]="50"
          rowHeight="auto"
          [scrollbarH]="true"
          [scrollbarV]="false"
          (activate)="editarRegistro($event)"
          [limit]="15"
          [rows]="rows"></ngx-datatable>
      </div> -->
    </div>
  </div>
  
</div>